// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3PQga","option":"styles_option__1STRa","selected":"styles_selected__llqBc"};